import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './section-title-plus.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL, wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import '../../atoms/buttons/generic-button2.0/index.js';

class SectionTitlePlus extends s {
    constructor() {
        super(...arguments);
        this.isRtl = '';
        this.imageSrc = '';
        this.imageAlt = '';
        this.imageDecorative = '';
        this.title = '';
        this.description = '';
        this.lang = '';
        this.ctaGroupLabel = 'Action buttons';
        this.size = 'large';
        this.headingLevel = 'h2';
        this.textAlign = 'left';
        this.titleColor = 'black';
        this.aspectRatio = '16:9';
        this.headingId = `section-title-${SectionTitlePlus.generateUniqueId()}`;
        this.ctaGroupId = `cta-group-${SectionTitlePlus.generateUniqueId()}`;
    }
    static generateUniqueId() {
        const id = `${Date.now()}-${SectionTitlePlus.idCounter}`;
        SectionTitlePlus.idCounter += 1;
        return id;
    }
    get isRtlEnabled() {
        return this.isRtl === 'isRtl' || isRTL();
    }
    getCtaContainerElement() {
        var _a, _b;
        return ((_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(SectionTitlePlus.CTA_CONTAINER_SELECTOR)) !== null && _b !== void 0 ? _b : null);
    }
    connectedCallback() {
        super.connectedCallback();
        this.validateTitle();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('title')) {
            this.validateTitle();
        }
    }
    firstUpdated() {
        this.setupKeyboardNavigation();
        this.setupCtaAnalytics();
    }
    validateTitle() {
        if (this.title && this.title.length > SectionTitlePlus.MAX_TITLE_LENGTH) {
            console.warn(`Title exceeds ${SectionTitlePlus.MAX_TITLE_LENGTH} characters. Current length: ${this.title.length}. Consider shortening for better readability.`);
        }
    }
    processTitleWithHighlight(title) {
        if (!title) {
            return o(title);
        }
        const regex = SectionTitlePlus.BOLD_REGEX;
        regex.lastIndex = 0; // Reset regex state
        const parts = [];
        let lastIndex = 0;
        let match;
        // eslint-disable-next-line no-cond-assign
        while ((match = regex.exec(title)) !== null) {
            // Add text before the match
            if (match.index > lastIndex) {
                parts.push(o(title.slice(lastIndex, match.index)));
            }
            // Add the highlighted text (match[2] is the content between markers)
            parts.push($ `<span class="section-title-plus__highlight">${o(match[2])}</span>`);
            lastIndex = regex.lastIndex;
        }
        // Add remaining text after last match
        if (lastIndex < title.length) {
            parts.push(o(title.slice(lastIndex)));
        }
        // If no matches found, return unsafeHTML of original title
        if (parts.length === 0) {
            return o(title);
        }
        return $ `${parts}`;
    }
    hasHighlightMarkers(title) {
        if (!title)
            return false;
        const regex = SectionTitlePlus.BOLD_REGEX;
        regex.lastIndex = 0;
        return regex.test(title);
    }
    renderGenericButton(type, ctaButton) {
        if (!(ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.url)) {
            return null;
        }
        const ctaLabel = ctaButton.title || '';
        const ctaHref = ctaButton.url;
        const ctaTarget = ctaButton.target || '_self';
        const ctaAriaLabel = ctaButton.ariaLabel || ctaButton.title || '';
        const ctaStyleType = 'light';
        return $ `<generic-button-updated type="${type}" .label="${ctaLabel}" .href="${ctaHref}" .target="${ctaTarget}" .styleType="${ctaStyleType}" .ariaList="${{
            label: ctaAriaLabel,
        }}" ?isNoFollow="${ctaButton.isNoFollow || false}" ?rtl="${this.isRtlEnabled}" class="cta-link cta-link--${type}"></generic-button-updated>`;
    }
    setupKeyboardNavigation() {
        const ctaContainer = this.getCtaContainerElement();
        if (!ctaContainer)
            return;
        ctaContainer.addEventListener('keydown', this.handleKeyboardNavigation.bind(this));
    }
    getInteractiveElements(ctaContainer) {
        const buttons = ctaContainer.querySelectorAll('generic-button-updated');
        const elements = [];
        buttons.forEach(button => {
            var _a;
            const buttonElement = (_a = button.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a, button');
            if (buttonElement) {
                elements.push(buttonElement);
            }
        });
        return elements;
    }
    handleKeyboardNavigation(event) {
        const e = event;
        const ctaContainer = this.getCtaContainerElement();
        if (!ctaContainer)
            return;
        const interactiveElements = this.getInteractiveElements(ctaContainer);
        if (interactiveElements.length === 0)
            return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            this.handleArrowKeyNavigation(e, interactiveElements);
        }
        else if (e.key === 'Home' || e.key === 'End') {
            this.handleHomeEndNavigation(e, interactiveElements);
        }
    }
    handleArrowKeyNavigation(e, elements) {
        var _a;
        e.preventDefault();
        const currentIndex = this.getCurrentElementIndex(elements);
        const nextIndex = this.calculateNextIndex(e.key, currentIndex, elements.length, this.isRtlEnabled);
        (_a = elements[nextIndex]) === null || _a === void 0 ? void 0 : _a.focus();
    }
    handleHomeEndNavigation(e, elements) {
        var _a, _b;
        e.preventDefault();
        if (e.key === 'Home') {
            (_a = elements[0]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else if (e.key === 'End') {
            (_b = elements[elements.length - 1]) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }
    getCurrentElementIndex(elements) {
        var _a;
        let { activeElement } = document;
        while ((_a = activeElement === null || activeElement === void 0 ? void 0 : activeElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement) {
            activeElement = activeElement.shadowRoot.activeElement;
        }
        return elements.indexOf(activeElement);
    }
    calculateNextIndex(key, currentIndex, totalElements, isRtl) {
        let nextIndex;
        if (key === 'ArrowRight') {
            nextIndex = isRtl ? currentIndex - 1 : currentIndex + 1;
        }
        else {
            nextIndex = isRtl ? currentIndex + 1 : currentIndex - 1;
        }
        return this.wrapIndex(nextIndex, totalElements);
    }
    wrapIndex(index, totalElements) {
        if (index >= totalElements)
            return 0;
        if (index < 0)
            return totalElements - 1;
        return index;
    }
    setupCtaAnalytics() {
        const ctaContainer = this.getCtaContainerElement();
        if (!ctaContainer)
            return;
        ctaContainer.addEventListener('click', this.handleCtaClick.bind(this));
    }
    handleCtaClick(e) {
        const target = e.target;
        const genericButton = target.closest('generic-button-updated');
        if (genericButton) {
            this.dispatchCtaAnalyticsEvent(genericButton);
        }
    }
    dispatchCtaAnalyticsEvent(genericButton) {
        var _a, _b;
        const { classList } = genericButton;
        const buttonType = classList.contains('cta-link--primary')
            ? 'primary'
            : 'secondary';
        const buttonElement = (_a = genericButton.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a, button');
        const buttonText = ((_b = buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '';
        const buttonHref = (buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.getAttribute('href')) || '';
        this.dispatchEvent(new CustomEvent('cta-click', {
            detail: {
                type: buttonType,
                text: buttonText,
                href: buttonHref,
                timestamp: Date.now(),
            },
            bubbles: true,
            composed: true,
        }));
    }
    renderImageMobile() {
        if (!this.imageSrc || this.textAlign === 'center')
            return w;
        return $ `<div class="section-title-plus__image-mobile"><generic-image src="${this.imageSrc}" alt="${this.imageAlt}" decorative="${this.imageDecorative}" aspect-ratio="${this.aspectRatio}" loading="eager"></generic-image></div>`;
    }
    renderImageDesktop() {
        if (!this.imageSrc || this.textAlign === 'center')
            return w;
        return $ `<div class="section-title-plus__image-desktop"><generic-image src="${this.imageSrc}" alt="${this.imageAlt}" decorative="${this.imageDecorative}" aspect-ratio="${this.aspectRatio}" loading="eager"></generic-image></div>`;
    }
    renderDescription() {
        if (!this.description)
            return w;
        return $ `<div class="section-title-plus__description rte${this.isRtlEnabled ? ' rte--rtl' : ''}">${o(wrapRichTextTables(this.description))}</div>`;
    }
    renderCtaGroup() {
        var _a, _b;
        const hasCtas = ((_a = this.primaryCta) === null || _a === void 0 ? void 0 : _a.url) || ((_b = this.secondaryCta) === null || _b === void 0 ? void 0 : _b.url);
        if (!hasCtas) {
            return w;
        }
        return $ `<div class="section-title-plus__cta-container" role="group" aria-labelledby="${this.headingId}" id="${this.ctaGroupId}">${this.renderGenericButton('primary', this.primaryCta)} ${this.renderGenericButton('secondary', this.secondaryCta)}</div>`;
    }
    renderTitle(processedTitle, hasHighlight) {
        const titleClass = `section-title-plus__title size-${this.size} color-${this.titleColor}${hasHighlight ? ' has-highlight' : ''}`;
        switch (this.headingLevel) {
            case 'h1':
                return $ `<h1 id="${this.headingId}" class="${titleClass}">${processedTitle}</h1>`;
            case 'h3':
                return $ `<h3 id="${this.headingId}" class="${titleClass}">${processedTitle}</h3>`;
            default:
                return $ `<h2 id="${this.headingId}" class="${titleClass}">${processedTitle}</h2>`;
        }
    }
    render() {
        const direction = this.isRtlEnabled ? 'rtl' : 'ltr';
        const isRtlClass = this.isRtlEnabled ? 'rtl' : '';
        const alignClass = this.textAlign === 'center' ? 'align-center' : '';
        const langAttr = this.lang ? this.lang : w;
        const processedTitle = this.processTitleWithHighlight(this.title);
        const hasHighlight = this.hasHighlightMarkers(this.title);
        return $ `<section class="section-title-plus ${isRtlClass} ${alignClass}" aria-labelledby="${this.headingId}" dir="${direction}" lang="${langAttr}"><div class="section-title-plus__content"><div class="section-title-plus__text-container">${this.renderTitle(processedTitle, hasHighlight)} ${this.renderImageMobile()} ${this.renderDescription()} ${this.renderCtaGroup()}</div>${this.renderImageDesktop()}</div></section>`;
    }
}
SectionTitlePlus.styles = css_248z;
SectionTitlePlus.MAX_TITLE_LENGTH = 130;
SectionTitlePlus.BOLD_REGEX = /(\*\*|__)(.+?)\1/g;
SectionTitlePlus.CTA_CONTAINER_SELECTOR = '.section-title-plus__cta-container';
SectionTitlePlus.idCounter = 0;
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "isRtl", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "imageSrc", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "imageAlt", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "imageDecorative", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "title", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "description", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "lang", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "ctaGroupLabel", void 0);
__decorate([
    e({ type: Object })
], SectionTitlePlus.prototype, "primaryCta", void 0);
__decorate([
    e({ type: Object })
], SectionTitlePlus.prototype, "secondaryCta", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "size", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "headingLevel", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "textAlign", void 0);
__decorate([
    e({ type: String })
], SectionTitlePlus.prototype, "titleColor", void 0);
__decorate([
    t()
], SectionTitlePlus.prototype, "aspectRatio", void 0);
customElements.define('section-title-plus', SectionTitlePlus);

export { SectionTitlePlus };
